import { legacyPlugins } from "/home/runner/work/cabral.ro/cabral.ro/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}